import { getIdToken, loginWithIdToken, startVPCAuthentication } from './authFunctions';

/**
 * This function will start the flow to let the user sign in at VPAuth (possibly without showing
 * the user login form) and open VPC.
 */
export const openVisionplanner = async ({ visionplannerDetails }) => {
  const idToken = await getIdToken();
  if (!idToken) {
    // startVPCAuthentication starts a new authentication flow, redirecting the
    // user to VPCAuth and back. Therefore, startVPCAuthentication won't return.
    startVPCAuthentication({
      authorizationServerUrl: visionplannerDetails.authorizationServerUrl,
      clientId: visionplannerDetails.clientId,
    });
  } else {
    loginWithIdToken({
      authorizationServerUrl: visionplannerDetails.authorizationServerUrl,
      idToken,
      redirectUrl: visionplannerDetails.visionplannerUrl,
      openInNewWindow: true,
    });
  }
};
